// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"6680b0a3","244":"57fc5c83","622":"40fe6cda","903":"ced12e17"}[chunkId] + ".chunk.js";
};